"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenHeader = void 0;

var _variables = require("../../../global-files/variables");

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

var ScreenHeader = function ScreenHeader(_ref) {
  var text = _ref.text,
      boldText = _ref.boldText,
      fontFamily = _ref.fontFamily,
      color = _ref.color,
      headerType = _ref.headerType,
      Paragraph = _ref.Paragraph;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    fontFamily: fontFamily,
    color: color,
    className: headerType,
    children: [text, " ", boldText && /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      children: [" ", boldText]
    }), Paragraph && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: Paragraph
    })]
  }, "title-".concat(text));
};

exports.ScreenHeader = ScreenHeader;
ScreenHeader.defaultProps = {
  text: "Header Text Default",
  fontFamily: "Raleway",
  color: _variables.GlobalColors.s5
};